/**
 * @Author: wuzhying
 * @Date: 2020-04-22 15:00
 * @Email: 253494078@qq.com
 */

import ax from '../../axios'

// 获取工单列表
export function getOrderAPI(params) {
    return ax({
        url: '/wlapi/tickets/mpSearch',
        method: 'POST',
        params
    })
}

// 已解决工单
export function processeOrderAPI(params) {
    return ax({
        url: '/wlapi/tickets/processed',
        method: 'POST',
        params
    })
}

// 关闭工单
export function closeOrderAPI(params) {
    return ax({
        url: '/wlapi/tickets/closed',
        method: 'POST',
        params
    })
}

// 删除工单
export function delOrderAPI(params) {
    return ax({
        url: '/wlapi/tickets/delTicket',
        method: 'POST',
        params
    })
}


// 重新打开工单
export function reopenOrderAPI(params) {
    return ax({
        url: '/wlapi/tickets/reopen',
        method: 'POST',
        params
    })
}

// 获取所有客服
export function getAllServiceAPI (params) {
  return ax({
    url: '/wlapi/tickets/allAgentCs',
    method: 'POST',
    params,
  })
}

// 获取工单分类
export function getWorkorderSortAPI (params) {
  return ax({
    url: '/wlapi/tickets/categoryList',
    method: 'POST',
    params,
  })
}

// 查询工单
export function ticketSearchAPI (params) {
  return ax({
    url: '/wlapi/tickets/ticketSearch',
    method: 'POST',
    data:params,
  })
}

/**
 * 对话-发送图片
 * @param {*} data
 */
export function chatSendImages (params) {
  return ax({
    url: '/wlapi/resource/uploadImgFile',
    method: 'POST',
    data:params
  })
}
/**
 * 获取聊天历史记录
 * @param {*} params
 */
export function getChatHistory (data) {
  return ax({
    url: '/wlapi/chat/history',
    method: 'POST',
    data
  })
}